<template>
	<div>
		<AddGroupModal v-model="form"/>
		<GroupList v-model="form"/>
	</div>
</template>

<script>
	import AddGroupModal from "./AddGroupModal";
	import GroupList from "./GroupList";

	export default {
		parent: "GroupPanel",
		components: {GroupList, AddGroupModal},

		props: {
			value: Object,
		},

		watch: {
			form: {
				handler() {
					this.$emit("input", this.form);
				}
				,
				deep: true,
			},
		},

		data() {
			return {
				form: this.value,
			};
		},
	};
</script>

<style scoped>

</style>
